import { r as registerInstance, h, g as getElement, c as createEvent, F as Fragment } from './index-16dc7dde.js';
import { o as omitBy_1, i as isNil_1 } from './omitBy-fb73ffc4.js';
import { i as isEmpty_1 } from './isEmpty-b60327cb.js';
import { p as pick_1 } from './pick-bfea8c03.js';
import { f as formatString } from './format-string-a043c0ab.js';
import { c as classnames } from './index-136476ff.js';
import { t as toNumber_1 } from './toNumber-5000b45d.js';
import './lookups-705fb53e.js';
import { p as parseCommonURLToRouterParts } from './url-parser-fe899a81.js';
import { s as send, k as documentDownloadEvent } from './send-33ade633.js';
import './request.constants-deb285e0.js';
import { i as isAnalyticsEnabled } from './helpers-71d81730.js';
import { l as getParamValueFromURL, au as openPopupCenter } from './utils-15ad90ec.js';
import { p as pesIconSizes } from './constants-e9ddcc22.js';
import { P as PesRoute } from './pes-route-63457678.js';
import { i as isAppRoutingEnabled, n as navigateWithRouter } from './utils-60b2d521.js';
import './_baseIteratee-506bcd8a.js';
import './_Uint8Array-2e849395.js';
import './identity-6651b537.js';
import './isTypedArray-dfccd669.js';
import './isObject-33fa1780.js';
import './_commonjsHelpers-ba3f0406.js';
import './isSymbol-45bfef0c.js';
import './toString-da636857.js';
import './_baseTimes-db8626dd.js';
import './_isIndex-af307327.js';
import './hasIn-6ce0da41.js';
import './_basePickBy-9e484e47.js';
import './_assignValue-8e900715.js';
import './_getAllKeysIn-8178afb2.js';
import './_flatRest-49cdf089.js';
import './_baseFlatten-2670ede5.js';
import './analytics-765d4daf.js';
import './pes-router-store-1a105b49.js';
import './index-634d378a.js';
import './utils-913bdf8a.js';
import './tslib.es6-2af8cb53.js';
import './currency-b61904e0.js';
import './parsers-e38ff6a5.js';

const NO_LETTERS_AND_LEADING_ZERO_REGEXP = /[^0-9]|^0{1}/g;
const NOT_SPECIFIED_PROPERTY_VAL = '—';
const RUNTIME_FIELD_MAX_LENGTH = 7;
const LOAD_PLACEHOLDER = '#load#';
const REQUIRED_RUNTIME_PARAMS = [
  'vah',
  'bcurveComp',
  'bcurveExpo',
  'bcurveSlope',
  'bcurveScale',
  'ptare',
];
const RUNTIME_ERROR_CODES = {
  EMPTY: 'errorEmpty',
  NULL_PARAM: 'errorHasNull',
  EXCEED_MAX_CAPACITY: 'errorExceedMaxCapacity',
  LESS_THAN_MINIMUM: 'errorLessThanMinimum',
};
const RUNTIME_LABEL_CODES = {
  PLEASE_ENTER_LOAD: 'pleaseEnterLoad',
  TOTAL_LOAD_EXCEEDS: 'totalLoadExceeds',
  ENTERED_LOAD_LESS_MINIMUM: 'enteredLoadLessMinimum',
  PLEASE_ENTER_LOAD_MAX_CAPACITY: 'pleaseEnterLoadMaxCapacity',
};
const RUNTIME_ERROR_CODES_TO_LABELS = {
  LOAD: {
    [RUNTIME_ERROR_CODES.EMPTY]: RUNTIME_LABEL_CODES.PLEASE_ENTER_LOAD,
    [RUNTIME_ERROR_CODES.EXCEED_MAX_CAPACITY]: RUNTIME_LABEL_CODES.TOTAL_LOAD_EXCEEDS,
    [RUNTIME_ERROR_CODES.LESS_THAN_MINIMUM]: RUNTIME_LABEL_CODES.ENTERED_LOAD_LESS_MINIMUM,
  },
  MAX_CAPACITY: {
    [RUNTIME_ERROR_CODES.EMPTY]: RUNTIME_LABEL_CODES.PLEASE_ENTER_LOAD_MAX_CAPACITY,
  },
};
const RUNTIME_FIELDS = {
  HOURS: 'hours',
  MINUTES: 'minutes',
  SECONDS: 'seconds',
};

function parseDecimal(value) {
  return parseInt(value, 10);
}
function calculateMaxCapacity(inputValue, pwrRated) {
  const value = parseDecimal(inputValue);
  return Math.round((value / pwrRated) * 100);
}
function calculateRuntimeMinutes(runtimeParams, calculatedValue) {
  const { vah, bcurveComp, bcurveExpo, bcurveSlope, bcurveScale, ptare } = runtimeParams;
  const mathPow = (vah / (calculatedValue + ptare)) ** bcurveExpo;
  return (60 * bcurveScale * (mathPow - bcurveSlope + (bcurveComp * (calculatedValue + ptare)) / vah));
}
function isMaxCapacityExceeded(value, pwrRated) {
  return parseDecimal(value) > pwrRated;
}
function isLoadLessThanMinimum(value, min) {
  return parseDecimal(value) < min;
}
function getMinValue(max, min) {
  return min !== null && min !== void 0 ? min : Math.ceil(max * 0.1);
}
function calculateRuntime(runtimeParams, value) {
  if (!value) {
    return null;
  }
  if (isMaxCapacityExceeded(value, runtimeParams.pwrRated)) {
    return null;
  }
  if (isLoadLessThanMinimum(value, getMinValue(runtimeParams.pwrRated, runtimeParams.startPoint))) {
    return null;
  }
  const runtime = calculateRuntimeMinutes(runtimeParams, parseDecimal(value));
  if (Number.isNaN(runtime) || runtime <= 0) {
    return null;
  }
  const resultRuntime = {};
  const runtimeMinutes = Math.floor(runtime);
  if (runtimeMinutes < 30) {
    resultRuntime.minutes = runtimeMinutes;
    resultRuntime.seconds = Math.floor((runtime - runtimeMinutes) * 60) || null;
  }
  if (runtimeMinutes >= 30 && runtimeMinutes < 60) {
    resultRuntime.minutes = runtimeMinutes;
  }
  if (runtimeMinutes >= 60) {
    resultRuntime.hours = Math.floor(runtimeMinutes / 60);
    resultRuntime.minutes = Math.floor(runtimeMinutes % 60) || null;
  }
  return omitBy_1(resultRuntime, isNil_1);
}
function stringifyRuntime(runtime, labels, defaultValue = NOT_SPECIFIED_PROPERTY_VAL) {
  if (isEmpty_1(runtime)) {
    return defaultValue;
  }
  return [RUNTIME_FIELDS.HOURS, RUNTIME_FIELDS.MINUTES, RUNTIME_FIELDS.SECONDS]
    .filter((field) => !isNil_1(runtime[field]))
    .map((field) => `${runtime[field]}${labels[field]}`)
    .join(' ');
}
function hasNullParams(runtimeParams) {
  const paramsValue = Object.values(pick_1(runtimeParams, REQUIRED_RUNTIME_PARAMS));
  return paramsValue.some(isNil_1);
}
function validate(runtimeParams, value) {
  const { pwrRated, startPoint } = runtimeParams !== null && runtimeParams !== void 0 ? runtimeParams : {};
  if (hasNullParams(runtimeParams)) {
    return RUNTIME_ERROR_CODES.NULL_PARAM;
  }
  if (!value) {
    return RUNTIME_ERROR_CODES.EMPTY;
  }
  if (isMaxCapacityExceeded(value, pwrRated)) {
    return RUNTIME_ERROR_CODES.EXCEED_MAX_CAPACITY;
  }
  if (isLoadLessThanMinimum(value, getMinValue(pwrRated, startPoint))) {
    return RUNTIME_ERROR_CODES.LESS_THAN_MINIMUM;
  }
  return null;
}
function formatMessage(message, labelCode, runtimeParams) {
  if (!message || !labelCode || isEmpty_1(runtimeParams)) {
    return message !== null && message !== void 0 ? message : null;
  }
  let load;
  const { pwrRated, startPoint } = runtimeParams;
  switch (labelCode) {
    case RUNTIME_LABEL_CODES.TOTAL_LOAD_EXCEEDS:
      load = pwrRated;
      break;
    case RUNTIME_LABEL_CODES.ENTERED_LOAD_LESS_MINIMUM:
      load = getMinValue(pwrRated, startPoint);
      break;
  }
  if (!load) {
    return message;
  }
  return formatString(message, {
    [LOAD_PLACEHOLDER]: load === null || load === void 0 ? void 0 : load.toString(),
  });
}

const pesMaxCapacityCellCss = ":host{display:block;line-height:1.25rem;font-size:0.875rem;color:#333333}.max-capacity-cell__indicator-container{display:flex;align-items:center}.max-capacity-cell__indicator{flex:1 1 100%;min-width:0}.max-capacity-cell__measure-unit{flex:1 0 auto;font-size:0.875rem;min-width:0}:host(:not([dir=\"rtl\"])) .max-capacity-cell__measure-unit{margin-left:14px}:host([dir=\"rtl\"]) .max-capacity-cell__measure-unit{margin-right:14px}";

let PesMaxCapacityCell = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.value = '';
    this.default = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  getValue() {
    if (!this.value || !this.runtimeParams.pwrRated) {
      return 0;
    }
    return calculateMaxCapacity(this.value, this.runtimeParams.pwrRated);
  }
  getErrorMessage(errorCode) {
    var _a, _b;
    const labelCode = RUNTIME_ERROR_CODES_TO_LABELS.MAX_CAPACITY[errorCode];
    return (_b = (_a = this.labels) === null || _a === void 0 ? void 0 : _a[labelCode]) !== null && _b !== void 0 ? _b : null;
  }
  render() {
    if (this.default) {
      return h("div", null);
    }
    const errorMessage = this.getErrorMessage(validate(this.runtimeParams, this.value));
    const value = this.getValue();
    return (h("pes-runtime-base-cell", null, h("div", { slot: "value" }, errorMessage ? (NOT_SPECIFIED_PROPERTY_VAL) : (h("div", { class: "max-capacity-cell__indicator-container" }, h("pes-rainbow-bar", { class: "max-capacity-cell__indicator", min: 0, max: 100, value: value }), h("span", { class: "max-capacity-cell__measure-unit" }, `${value !== null && value !== void 0 ? value : 0} %`)))), errorMessage && h("div", { slot: "error" }, errorMessage)));
  }
  get el() { return getElement(this); }
};
PesMaxCapacityCell.style = pesMaxCapacityCellCss;

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

var _baseClamp = baseClamp;

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = toNumber_1(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = toNumber_1(lower);
    lower = lower === lower ? lower : 0;
  }
  return _baseClamp(toNumber_1(number), lower, upper);
}

var clamp_1 = clamp;

const calculateFillPct = ({ min, max, value, }) => {
  if (max === 0 || max - min <= 0) {
    return 0;
  }
  const calculated = Math.round(((value - min) / (max - min)) * 1000) / 10;
  return clamp_1(calculated, 0, 100);
};

const pesRainbowBarCss = ":host{display:block}:host(:not([dir=rtl])) .rainbow-bar__gray::before{box-shadow:none}.rainbow-bar{min-width:130px;height:5px;border-radius:2.5px;position:relative;overflow:hidden}@media screen and (max-width: 719px){.rainbow-bar{min-width:90px}}.rainbow-bar__progress{height:5px;position:absolute;border-radius:2.5px;top:0;bottom:0;width:100%}:host(:not([dir=\"rtl\"])) .rainbow-bar__progress{left:0;background:linear-gradient(to right, #3dcd58 49%, #ffd100 89%, #e47f00 96%, #b10043 100%)}:host([dir=\"rtl\"]) .rainbow-bar__progress{right:0;background:linear-gradient(to left, #3dcd58 49%, #ffd100 89%, #e47f00 96%, #b10043 100%)}.rainbow-bar__progress--error{background:#b10043 !important}.rainbow-bar__gray{height:5px;position:absolute;top:0;bottom:0;background-color:#e6e6e6;width:0;border-radius:0}:host(:not([dir=\"rtl\"])) .rainbow-bar__gray{right:-12px}:host([dir=\"rtl\"]) .rainbow-bar__gray{left:-12px}.rainbow-bar__gray::before{content:\"\";display:block;position:relative;width:36px;height:100%;box-shadow:11px 0 0 0 #e6e6e6}:host(:not([dir=\"rtl\"])) .rainbow-bar__gray::before{border-top-right-radius:54px;border-bottom-right-radius:54px;left:-48px}:host([dir=\"rtl\"]) .rainbow-bar__gray::before{border-top-left-radius:54px;border-bottom-left-radius:54px;right:-48px}.rainbow-bar__gray::after{content:\"\";position:absolute;display:block;height:100%;background-color:#e6e6e6;width:20px;top:0}:host(:not([dir=\"rtl\"])) .rainbow-bar__gray::after{left:-12px}:host([dir=\"rtl\"]) .rainbow-bar__gray::after{right:-12px}";

let PesRainbowBar = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.min = 0;
    this.max = 100;
    this.value = 50;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    const { min, max, value } = this;
    const pct = calculateFillPct({ min, max, value });
    const greyWidth = pct === 0 ? '100%' : `${100 - pct}%`;
    const isError = value > max;
    return (h("div", { class: "rainbow-bar" }, h("div", { class: classnames('rainbow-bar__progress', {
        'rainbow-bar__progress--error': isError,
      }) }), h("div", { class: "rainbow-bar__gray", style: { width: greyWidth } })));
  }
  get el() { return getElement(this); }
};
PesRainbowBar.style = pesRainbowBarCss;

const pesRuntimeFieldCss = ":host{display:block;font-size:0.875rem;line-height:1.25rem;color:inherit}@media screen and (max-width: 979px){:host{padding-top:6px}}.runtime-field__row{display:flex;align-items:center}.runtime-field__row+.runtime-field__row{margin-top:6px}.runtime-field__label{color:inherit}:host(:not([dir=\"rtl\"])) .runtime-field__label{margin-right:8px}:host([dir=\"rtl\"]) .runtime-field__label{margin-left:8px}.runtime-field__input{box-sizing:border-box;color:#333333;font-size:1rem;line-height:inherit;height:30px;width:58px;padding:0 8px;font-weight:normal;border:1px solid #cbcbcb;outline:none}.runtime-field__input *,.runtime-field__input *::before,.runtime-field__input *::after{box-sizing:inherit}.runtime-field__input:focus,.runtime-field__input:active{border-color:#333333}.runtime-field__input--error{border-color:#b10043}.runtime-field__measure{color:#333333;font-weight:normal}:host(:not([dir=\"rtl\"])) .runtime-field__measure{margin-left:4px}:host([dir=\"rtl\"]) .runtime-field__measure{margin-right:4px}.runtime-field__load-range{display:flex;align-items:center;font-weight:normal;color:#9fa0a4}@media screen and (max-width: 979px){.runtime-field__load-range{padding-top:2px}}";

let RuntimeField = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.pesRuntimeDidSubmit = createEvent(this, "pesRuntimeDidSubmit", 7);
    this.pesRuntimeDidInput = createEvent(this, "pesRuntimeDidInput", 7);
    this.inputRef = null;
    this.selectValue = '';
    this.isError = false;
    this.defaultValue = '';
    this.hideMinMaxRange = false;
    this.value = '';
    this.getSelectValue = ({ target }) => {
      this.selectValue = target.value;
    };
    this.handleInput = (event) => {
      const target = event.target;
      let { value } = target;
      if (NO_LETTERS_AND_LEADING_ZERO_REGEXP.test(value)) {
        value = this.selectValue + value.replace(NO_LETTERS_AND_LEADING_ZERO_REGEXP, '');
      }
      this.selectValue = '';
      this.setValue(value);
    };
    this.handleChange = (event) => {
      const { value } = event.target;
      this.pesRuntimeDidSubmit.emit(value);
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  handleValueChange(value) {
    this.pesRuntimeDidInput.emit(value);
  }
  componentDidLoad() {
    var _a;
    (_a = this.inputRef) === null || _a === void 0 ? void 0 : _a.addEventListener('select', this.getSelectValue);
    this.setValue(this.defaultValue);
  }
  setValue(value) {
    this.inputRef.value = this.value = value;
  }
  getLoadRangeText() {
    var _a, _b;
    return `${(_a = this.labels) === null || _a === void 0 ? void 0 : _a.minMax} ${getMinValue(this.max, this.min)}-${this.max} ${(_b = this.labels) === null || _b === void 0 ? void 0 : _b.watts}`;
  }
  render() {
    var _a, _b, _c, _d;
    return (h("div", { class: "runtime-field" }, h("pes-runtime-heading-cell", { class: "runtime-field__row", tooltipText: (_a = this.labels) === null || _a === void 0 ? void 0 : _a.enterTotalLoad }, h("div", { class: "runtime-field__label" }, (_b = this.labels) === null || _b === void 0 ? void 0 : _b.runTime), h("input", { class: {
        'runtime-field__input': true,
        'runtime-field__input--error': this.isError,
      }, type: "text", maxLength: RUNTIME_FIELD_MAX_LENGTH, ref: (el) => {
        this.inputRef = el;
      }, onTouchStart: this.getSelectValue, onInput: this.handleInput, onChange: this.handleChange }), ((_c = this.labels) === null || _c === void 0 ? void 0 : _c.watts) && h("span", { class: "runtime-field__measure" }, (_d = this.labels) === null || _d === void 0 ? void 0 : _d.watts)), !this.hideMinMaxRange && (h("div", { class: "runtime-field__row" }, h("div", { class: "runtime-field__load-range" }, h("span", { class: "runtime-field__load-range-text" }, this.getLoadRangeText()))))));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "value": ["handleValueChange"]
  }; }
};
RuntimeField.style = pesRuntimeFieldCss;

const pesRuntimeHeadingCellCss = ":host{display:block;font-size:0.875rem;line-height:1.25rem;font-weight:bold;color:inherit}.runtime-heading{display:flex;align-items:center}.runtime-heading__label{color:inherit;display:flex;align-items:center}.runtime-heading__tooltip{color:#333333;font-weight:normal;width:16px;height:16px}:host(:not([dir=\"rtl\"])) .runtime-heading__tooltip{margin-left:4px}:host([dir=\"rtl\"]) .runtime-heading__tooltip{margin-right:4px}";

let RuntimeBaseCell = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: "runtime-heading" }, h("div", { class: "runtime-heading__label" }, h("slot", null)), this.tooltipText && (h("pdp-icon-tooltip", { class: "runtime-heading__tooltip", icon: "information_stroke", iconSize: "micro", iconColor: "grey", position: "top" }, this.tooltipText))));
  }
  get el() { return getElement(this); }
};
RuntimeBaseCell.style = pesRuntimeHeadingCellCss;

const pesRuntimeLoadCellCss = ":host{display:block;font-size:0.875rem;line-height:1.25rem;color:#333333}@media screen and (max-width: 979px){:host{padding-top:14px;padding-bottom:8px}}";

let RuntimeLoadCell = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.value = '';
    this.default = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  getErrorMessage(errorCode) {
    var _a;
    const labelCode = RUNTIME_ERROR_CODES_TO_LABELS.LOAD[errorCode];
    const message = (_a = this.labels) === null || _a === void 0 ? void 0 : _a[labelCode];
    return formatMessage(message, labelCode, this.runtimeParams);
  }
  render() {
    if (this.default) {
      return h("div", null);
    }
    const errorMessage = this.getErrorMessage(validate(this.runtimeParams, this.value));
    const value = errorMessage ? null : calculateRuntime(this.runtimeParams, this.value);
    return (h("pes-runtime-base-cell", null, h("div", { slot: "value" }, stringifyRuntime(value, this.labels)), errorMessage && h("div", { slot: "error" }, errorMessage)));
  }
  get el() { return getElement(this); }
};
RuntimeLoadCell.style = pesRuntimeLoadCellCss;

const sectionWithHeaderCss = ".se-container-wide{max-width:1200px;margin-left:auto;margin-right:auto;padding-left:15px;padding-right:15px}@media screen and (min-width: 980px){.se-container-wide{padding-left:10px;padding-right:10px}}:host{display:block;background-color:#ffffff;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}@media screen and (min-width: 980px){.section{padding:56px 10px 72px;max-width:1200px;margin:0 auto;margin-bottom:8px}}@media screen and (min-width: 980px){.section--with-columns{display:flex;flex-direction:row}}.section--with-columns .section__content{width:780px}.section__heading{display:block}@media screen and (min-width: 980px){.section__heading{margin-bottom:20px}}@media screen and (min-width: 980px){.section--with-columns .section__heading{width:25%;max-width:300px}:host(:not([dir=\"rtl\"])) .section--with-columns .section__heading{padding-right:24px}:host([dir=\"rtl\"]) .section--with-columns .section__heading{padding-left:24px}}";

let SectionWithHeader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.withColumns = false;
    this.color = 'default';
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("section", { class: classnames('section', this.withColumns && 'section--with-columns') }, h("pes-section-header", { class: "section__heading", color: this.color }, this.headingLabel), h("div", { class: "section__content" }, h("slot", null))));
  }
  get el() { return getElement(this); }
};
SectionWithHeader.style = sectionWithHeaderCss;

const specificationsTableCss = ":host{display:block;box-sizing:border-box}:host *,:host *::before,:host *::after{box-sizing:inherit}.specifications-table{font-size:14px;line-height:20px;font-weight:400;color:#333333;width:100%;height:auto;border-collapse:collapse;max-width:980px}.specifications-table__caption{font-size:16px;background-color:#f3f2f2;color:#333333}:host(:not([dir=\"rtl\"])) .specifications-table__caption{padding:0 24px 0 15px;text-align:left}:host([dir=\"rtl\"]) .specifications-table__caption{padding:0 15px 0 24px;text-align:right}@media screen and (max-width: 979px){.specifications-table__caption{line-height:45px}}@media screen and (min-width: 980px){.specifications-table__caption{line-height:40px}}.specifications-table__row{border-bottom:1px solid #e7e6e6;display:flex;flex-direction:column}@media screen and (max-width: 979px){.specifications-table__row{padding:10px 0;margin:0 15px}}@media screen and (min-width: 980px){.specifications-table__row{padding:14px 0;flex-direction:row}}.specifications-table__row:last-child{border:none}.specifications-table__cell,.specifications-table__row-heading{vertical-align:top;white-space:normal;padding:0}:host(:not([dir=\"rtl\"])) .specifications-table__cell,:host(:not([dir=\"rtl\"])) .specifications-table__row-heading{text-align:left}:host([dir=\"rtl\"]) .specifications-table__cell,:host([dir=\"rtl\"]) .specifications-table__row-heading{text-align:right}@media screen and (max-width: 979px){.specifications-table__row-heading{padding-bottom:4px}}@media screen and (min-width: 980px){.specifications-table__row-heading{width:32.3%}:host(:not([dir=\"rtl\"])) .specifications-table__row-heading{padding-left:15px}:host([dir=\"rtl\"]) .specifications-table__row-heading{padding-right:15px}}@media screen and (min-width: 980px){.specifications-table__cell{max-width:67.7%}:host(:not([dir=\"rtl\"])) .specifications-table__cell{padding-left:24px}:host([dir=\"rtl\"]) .specifications-table__cell{padding-right:24px}}@media screen and (max-width: 979px){.specifications-table__max-capacity{padding-top:4px}}.specifications-table__max-capacity-bar{width:250px}@media screen and (max-width: 979px){.specifications-table__max-capacity-bar{width:100%;padding-top:10px;padding-bottom:8px}}.specifications-table__link{cursor:pointer;display:inline-block;font-weight:400;font-size:14px;color:#42b4e6;text-decoration:none}:host(:not([dir=\"rtl\"])) .specifications-table__link{padding-right:10px}:host([dir=\"rtl\"]) .specifications-table__link{padding-left:10px}@media screen and (min-width: 980px){.specifications-table__link{display:block;padding:0}}.specifications-table__link:hover .specifications-table__link-text{text-decoration:underline}.specifications-table__link-icon{display:inline-block}:host(:not([dir=\"rtl\"])) .specifications-table__link-icon{margin-left:4px}:host([dir=\"rtl\"]) .specifications-table__link-icon{margin-right:4px}.specifications-table__text--first-letter-uppercase{display:inline-block}.specifications-table__text--first-letter-uppercase:first-letter{text-transform:uppercase}";

let SpecificationsTable = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.onExternalLinkHandler = (link, event) => {
      var _a, _b;
      const documentId = getParamValueFromURL(link, 'p_Doc_Ref');
      const documentName = (_a = getParamValueFromURL(link, 'p_File_Name|p_Archive_Name')) !== null && _a !== void 0 ? _a : '';
      const documentType = (_b = getParamValueFromURL(link, 'p_enDocType')) !== null && _b !== void 0 ? _b : '';
      if (documentId) {
        send(documentDownloadEvent, { documentId, documentName, documentType });
      }
      else if (isAppRoutingEnabled()) {
        event.preventDefault();
        const { pageType, pageId } = parseCommonURLToRouterParts(link);
        const route = new PesRoute({ page: pageType, pageId });
        navigateWithRouter(route, event.currentTarget);
      }
    };
    this.handleRuntimeSubmit = (event) => {
      this.runtimeValue = event.detail;
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  generateUrl(productUrl) {
    if (isAppRoutingEnabled()) {
      const { pageType, pageId } = parseCommonURLToRouterParts(productUrl);
      this.route = new PesRoute({ page: pageType, pageId });
      return this.route.url;
    }
    return productUrl;
  }
  componentWillLoad() {
    var _a, _b;
    this.runtimeValue = (_b = (_a = this.runtimeInfo) === null || _a === void 0 ? void 0 : _a.product) === null || _b === void 0 ? void 0 : _b.pwrRated;
  }
  isRuntimeError() {
    var _a;
    return Boolean(validate((_a = this.runtimeInfo) === null || _a === void 0 ? void 0 : _a.product, this.runtimeValue));
  }
  render() {
    var _a, _b, _c, _d, _e;
    return (h("table", { class: "specifications-table" }, h("caption", { class: "specifications-table__caption" }, this.data.tableName), h("tbody", null, this.runtimeInfo && (h(Fragment, null, h("tr", { class: "specifications-table__row" }, h("th", { class: "specifications-table__row-heading" }, h("pes-runtime-field", { onPesRuntimeDidSubmit: this.handleRuntimeSubmit, isError: this.isRuntimeError(), min: (_a = this.runtimeInfo.product) === null || _a === void 0 ? void 0 : _a.startPoint, max: (_b = this.runtimeInfo.product) === null || _b === void 0 ? void 0 : _b.pwrRated, labels: this.runtimeInfo.translations, defaultValue: String((_c = this.runtimeInfo.product) === null || _c === void 0 ? void 0 : _c.pwrRated) })), h("td", { class: "specifications-table__cell" }, h("pes-runtime-load-cell", { labels: this.runtimeInfo.translations, runtimeParams: this.runtimeInfo.product, value: this.runtimeValue }))), h("tr", { class: "specifications-table__row" }, h("th", { class: "specifications-table__row-heading" }, h("pes-runtime-heading-cell", { class: "specifications-table__max-capacity", tooltipText: this.runtimeInfo.translations.indicatesCapacity }, this.runtimeInfo.translations.maxCapacityUsed)), h("td", { class: "specifications-table__cell" }, h("pes-max-capacity-cell", { class: "specifications-table__max-capacity-bar", labels: this.runtimeInfo.translations, runtimeParams: this.runtimeInfo.product, value: this.runtimeValue }))))), (_e = (_d = this.data) === null || _d === void 0 ? void 0 : _d.rows) === null || _e === void 0 ? void 0 :
      _e.map((row) => {
        var _a;
        return (h("tr", { class: "specifications-table__row" }, h("th", { class: "specifications-table__row-heading" }, row.characteristicName), h("td", { class: "specifications-table__cell" }, (_a = row.characteristicValues) === null || _a === void 0 ? void 0 : _a.map((detail) => [
          detail.beforeText && h("div", { innerHTML: detail.beforeText }),
          !detail.beforeText && detail.value && h("div", { innerHTML: detail.value }),
          detail.externalUrl ? (h("a", { href: !detail.openPopup ? this.generateUrl(detail.externalUrl) : '#', class: "specifications-table__link", target: !detail.openPopup && (detail.displayLinkIcon ? '_blank' : '_self'), onClick: (e) => {
              if (detail.openPopup) {
                e.preventDefault();
                openPopupCenter({
                  url: detail.externalUrl,
                  title: '',
                });
              }
              isAnalyticsEnabled() && this.onExternalLinkHandler(detail.externalUrl, e);
            } }, h("span", { class: "specifications-table__link-text", innerHTML: detail.labelText }), detail.displayLinkIcon && (h("pes-icon", { size: pesIconSizes.MICRO, class: "specifications-table__link-icon" }, "action_new_window")))) : (h("span", { class: classnames('specifications-table__text', detail.needUpperCase
              && 'specifications-table__text--first-letter-uppercase'), innerHTML: detail.labelText })),
          detail.afterText && h("div", { innerHTML: detail.afterText }),
        ]))));
      }))));
  }
  get el() { return getElement(this); }
};
SpecificationsTable.style = specificationsTableCss;

export { PesMaxCapacityCell as pes_max_capacity_cell, PesRainbowBar as pes_rainbow_bar, RuntimeField as pes_runtime_field, RuntimeBaseCell as pes_runtime_heading_cell, RuntimeLoadCell as pes_runtime_load_cell, SectionWithHeader as pes_section_with_header, SpecificationsTable as pes_specifications_table };
